$(function () {
	// ロード画面の制御
	$("a").on('click', function (event) {
		event.preventDefault();
		var linkUrl = $(this).attr('href');
		if (Boolean(linkUrl)) {
			$(".pageloader").addClass("is-active");
			setTimeout(() => {
				location.href = linkUrl;
			}, 100);
		}
	});

	$("[data-target='navbar-menu']").on("click", function () {
		$(this).toggleClass("is-active");
		$("#navbar-menu").toggleClass("is-active");
	});
});
// ロード画面の制御
$(window).on('load', function () {
	if ($(".pageloader").hasClass("is-active")) {
		$(".pageloader").removeClass("is-active");
	}
});
$(window).on('pageshow', function () {
	if ($(".pageloader").hasClass("is-active")) {
		$(".pageloader").removeClass("is-active");
	}
});
